import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 防止访问重复路由报错
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

let commonRoutes = [{
	path: '/W0c09USOUCYsMfwkwL',
	name: 'login',
	meta: {
		title: '登录页面',
	},
	component: () => import('../views/auth/Login.vue'),
}]

//创建路由方法
const createRouter = () => new VueRouter({
	mode: 'history',
	routes: commonRoutes
})

const router = createRouter()

//重置路由,并添加路由
// router.$addRoutes = params => {
//   router.matcher = new VueRouter({
//     routes: commonRoutes
//   }).matcher;
//   router.addRoutes(params);
// };

// 重置路由
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
